const isSelf = (id, personId) => Number(id) === Number(personId)

export default isSelf
